import { datadogRum } from '@datadog/browser-rum';
import { CatchError } from '@guildeducationinc/recess';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';

interface ErrorBoundaryProps {
  errorDisplay?: React.ReactElement;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children, errorDisplay }) => {
  return (
    <CatchError
      as={(error, componentStack) => {
        datadogRum.addError(error, {
          message: `[Critical] Home crashed: ${error.message}`,
          stack: error.stack,
          errorName: error.name,
          componentInfo: componentStack,
        });
        return errorDisplay || <ErrorMessage />;
      }}
      silent
    >
      {children}
    </CatchError>
  );
};

export default ErrorBoundary;
